import { authSubscription } from './AuthStore';

export const updateAuthSubscription = (value) => authSubscription.update((oldValue) => value);
